module.exports = __webpack_public_path__ + "img/08.d5802364.jpg";